// extracted by mini-css-extract-plugin
export default {"content":"Content_content__3bkvH","linkPost":"Content_linkPost__e6vVH","linkAuthor":"Content_linkAuthor__+ZScM"};